import { css } from '@emotion/css'
import colors from '@styles/colors';
import { mobileOnly, tabletPortraitUp, tabletLandscapeUp, desktopUp } from '@styles/breakpoints';
import ApplePayIcon from "@img/checkout/apple-pay.png";

export default {
    pageContainer: css({
        padding: '0 !important',
    }),

    paymentMethods: css({
        marginBottom: 30,

        '.cards': {
            display: 'flex',
        },

        p: {
            fontWeight: 'bold',
            fontSize: 24,
            lineHeight: 1.35,
            letterSpacing: '0.02em',
            color: '#3856A7',
            marginBottom: 15,
        },

        '.separator' : {
            width: '100%',
            height: 2,
            backgroundColor: colors.BLUE
        },

        '.option-wrapper': {
            border: `2px solid ${colors.BLUE}`,
            marginTop: 10,
            borderRadius: 5,
            position: 'relative',

            '.option-content': {
                display: 'flex',
                flexDirection: 'row',
                flexWrap: 'nowrap',
                alignContent: 'center',
                alignItems: 'center',
                justifyContent: 'space-between',
                padding: 20,
            },

            '.option-content-stripe': {
                [mobileOnly]: {
                    alignItems: 'flex-start',
                    flexDirection: 'column',
                }
            },

            '.icons': {
                display: 'flex',
                gap: 10,
                flexDirection: 'row',
                flexWrap: 'wrap',
                alignContent: 'center',
                justifyContent: 'flex-end',
                alignItems: 'center',
            },

            label : {
                textTransform: 'capitalize',
                paddingTop: 3,
                paddingLeft: 28,
                paddingRight: 28,
            }
        },

        '.form-wrapper': {
            '.stripe-inputs': {
                marginTop: 10,
                marginBottom: '10px !important',
            }
        }
    }),

    autocompleteDropdownContainer: css({
        position: 'absolute',
        zIndex: 2,
        width: '100%',
        border: 'solid 1px #eee',
        background: colors.WHITE,
        borderBottomLeftRadius: 5,
        borderBottomRightRadius: 5,
        WebkitBoxShadow: `${colors.BLACK_15} 0px 3px 7px`,
        boxShadow: `${colors.BLACK_15} 0px 3px 7px`,

        '.suggestion-item': {
            backgroundColor: '#ffffff',
            cursor: 'pointer',
            minHeight: '30px',
            fontSize: 14,
            padding: '6px 10px',

            '&.active': {
                backgroundColor: '#eff1f8',
            },
        },

        '.powered-by': {
            height: 30,
            width: '100%',
            padding: '5px 10px',
            display: 'flex',
            justifyContent: 'flex-end',
            backgroundColor: '#ffffff',

            img: {
                width: 100,
                height: 13,
            },
        },

        '.loader': {
            height: 40,
            lineHeight: 50,
            textAlign: 'center',
            borderBottom: 0,
        },
    }),

    stripeInput: css({
        display: 'block',
        marginTop: 4,
        padding: '16px 20px',
        minWidth: '100%',
        maxWidth: '100%',
        border: 'solid 2px rgba(56, 86, 167, 0.2)',
        backgroundColor: colors.WHITE,
        borderRadius: 5,
        fontWeight: 600,
        lineHeight: '115%',
        letterSpacing: '0.01em',
        height: 54,
        color: colors.BLUE,
        width: '100%',
        fontSize: 16,

        '&:hover': {
            borderColor: colors.BLUE_60,
        },

        '&:focus, :active': {
            borderColor: colors.BLUE,
        },

        '::placeholder': {
            color: colors.BLUE_LIGHT,
        },

        '&.error': {
            border: `solid 2px ${colors.RED}`,
            color: colors.RED,
        }
    }),

    stripe: css({
        '.two-inputs-holder': {
            margin: '0 -7px',
            display: 'flex',

            '.input-wrap': {
                width: '50%',
                padding: '0 7px',

                '&:first-child': {
                    width: '60%',
                    [tabletPortraitUp]: {
                        width: '50%',
                    },
                },

                '&:last-child': {
                    width: '40%',
                    [tabletPortraitUp]: {
                        width: '50%',
                    },
                },
            },
            '&.client-name': {
                [mobileOnly]: {
                    display: 'block',
                    margin: 0,

                    '.input-wrap': {
                        width: '100%',
                        padding: 0,
                    },
                },
            },
        },

        'p.checkout-title': {
            fontWeight: 'bold',
            fontSize: 24,
            lineHeight: 1.35,
            letterSpacing: '0.02em',
            color: colors.BLUE,
            marginBottom: 15,
            display: 'inline-block',
        },

        '.input-wrap': {
            label: {
                position: 'relative',

                'input[type=password], input[type=email], input[type=text], input[type=tel], select': {
                    margin: '0 0 15px 0',
                    height: 54,
                    color: colors.NAVY,
                    width: '100%',
                    fontSize: 15,
                    WebkitAppearance: 'none', //mobile safari OS bug fixing
                    '&.select-dropdown': {
                        color: colors.NAVY,
                    },
                    '&::placeholder': {
                        color: colors.BLUE,
                        opacity: 0.5,
                    },
                },
                '.select__single-value': {
                    color: `${colors.NAVY} !important`,
                },
                '.floating-label': {
                    position: 'absolute',
                    pointerEvents: 'none',
                    opacity: 0.5,
                    color: colors.BLUE,
                    left: 22,
                    top: 18,
                    transition: '0.2s ease all',
                    fontSize: 15,
                    lineHeight: '1.2',
                    whiteSpace: 'nowrap',

                    '&.active': {
                        top: 8,
                        bottom: 10,
                        left: 20,
                        fontSize: 13,
                    },
                },
                '.input-floating': {
                    padding: '19px 20px 7px 20px',
                },
                '.select__control': {
                    margin: 0,
                    '.select__input': {
                        input: {
                            height: 30,
                        }
                    },
                },
                '&.select': {
                    position: 'relative',

                    '&:after': {
                        display: 'block',
                        borderTop: '2px solid #3856A7',
                        borderRight: '2px solid #3856A7',
                        WebkitTransform: 'rotate(135deg)',
                        MozTransform: 'rotate(135deg)',
                        MsTransform: 'rotate(135deg)',
                        OTransform: 'rotate(135deg)',
                        transform: 'rotate(135deg)',
                        height: 10,
                        width: 10,
                        content: '" "',
                        position: 'absolute',
                        top: '50%',
                        right: 20,
                        marginTop: '-6px',
                        zIndex: 1,
                    },
                },
            }
        },
    }),

    container: css({
        maxWidth: 1280,
        margin: '0 auto',

        label: {
            paddingBottom: '7px !important',
        },
        input: {
            margin: '0 !important',
            [mobileOnly]: {
                fontSize: '16px !important',
            },
        },
        '.form-row': {
            display: 'flex',
            flexWrap: 'wrap',

            '.form-column-left': {
                width: '100%',
                [tabletLandscapeUp]: {
                    width: '60%',
                },
            },
            '.form-column-right': {
                width: '100%',
                [tabletLandscapeUp]: {
                    width: '40%',
                },
            },
        },
        '.container-checkbox': {
            paddingBottom: 5,
            span: {
                fontSize: 15,
            }
        },
        '.sms-legal': {
            color: colors.BLUE,
            fontWeight: 500,
            fontSize: 13,
            lineHeight: '115%',
            letterSpacing: '0.01em',
            marginBottom: 30,
            marginTop: -20,
        },
        '.input-wrap': {
            label: {
                position: 'relative',

                'input[type=password], input[type=email], input[type=text], input[type=tel], select': {
                    margin: '0 0 15px 0',
                    height: 54,
                    color: colors.NAVY,
                    width: '100%',
                    fontSize: 15,
                    WebkitAppearance: 'none', //mobile safari OS bug fixing
                    '&.select-dropdown': {
                        color: colors.NAVY,
                    },
                    '&::placeholder': {
                        color: colors.BLUE,
                        opacity: 0.5,
                    },
                },

                '.select__control--is-disabled': {
                    backgroundColor: 'rgba(239, 239, 239, 0.3) !important',
                },

                '.select__single-value': {
                    color: `${colors.NAVY} !important`,
                },
                '.floating-label': {
                    position: 'absolute',
                    pointerEvents: 'none',
                    opacity: 0.5,
                    color: colors.BLUE,
                    left: 22,
                    top: 18,
                    transition: '0.2s ease all',
                    fontSize: 15,
                    lineHeight: '1.2',
                    whiteSpace: 'nowrap',
                    [mobileOnly]: {
                        fontSize: 16,
                    },

                    '&.active': {
                        top: 8,
                        bottom: 10,
                        left: 20,
                        fontSize: 13,
                    },
                },
                '.input-floating': {
                    padding: '19px 20px 7px 20px',
                },
                '.select__control': {
                    margin: 0,
                    '.select__input': {
                        input: {
                            height: 30,
                        }
                    },
                },
                '&.select': {
                    position: 'relative',

                    '&:after': {
                        display: 'block',
                        borderTop: '2px solid #3856A7',
                        borderRight: '2px solid #3856A7',
                        WebkitTransform: 'rotate(135deg)',
                        MozTransform: 'rotate(135deg)',
                        MsTransform: 'rotate(135deg)',
                        OTransform: 'rotate(135deg)',
                        transform: 'rotate(135deg)',
                        height: 10,
                        width: 10,
                        content: '" "',
                        position: 'absolute',
                        top: '50%',
                        right: 20,
                        marginTop: '-6px',
                        zIndex: 1,
                    },
                },
            }
        },

        '.form-wrap': {
            float: 'none',
            padding: '40px 20px 0 20px',

            [tabletPortraitUp]: {
                padding: '40px 40px 25px 40px',
            },
            [tabletLandscapeUp]: {
                padding: '50px 60px 45px 90px',
            },
            [desktopUp]: {
                float: 'left',
                width: '100%',
                padding: '50px 100px 40px 100px',
            }
        },

        '.checkout-block': {
            marginBottom: 20,
        },

        '.checkout-block-offset': {
            marginTop: 34,
        },

        'p.checkout-title': {
            fontWeight: 'bold',
            fontSize: 24,
            lineHeight: 1.35,
            letterSpacing: '0.02em',
            color: colors.BLUE,
            marginBottom: 15,
        },

        'p.login-here': {
            fontWeight: 600,
            fontSize: 16,
            letterSpacing: '0.01em',
            color: colors.BLUE,

            span: {
                color: colors.RED,

                a: {
                    position: 'relative',
                    textDecoration: 'none',

                    '&:after': {
                        content: '" "',
                        position: 'absolute',
                        bottom: 0,
                        left: 0,
                        width: '100%',
                        height: 2,
                        backgroundColor: colors.RED,
                    },
                },
            },

            p: {
                fontSize: 10,
            }
        },

        '.two-inputs-holder': {
            margin: '0 -7px',
            display: 'flex',

            '.input-wrap': {
                width: '50%',
                padding: '0 7px',

                '&:first-child': {
                    width: '60%',
                    [tabletPortraitUp]: {
                        width: '50%',
                    },
                },

                '&:last-child': {
                    width: '40%',
                    [tabletPortraitUp]: {
                        width: '50%',
                    },
                },
            },
            '&.client-name': {
                [mobileOnly]: {
                    display: 'block',
                    margin: 0,

                    '.input-wrap': {
                        width: '100%',
                        padding: 0,
                    },
                },
            },
        },
    }),

    ApplePayButton: css({
        width: '100%',
        height: '40px',
        backgroundColor: 'black',
        backgroundImage: `url(${ApplePayIcon})`,
        backgroundPosition: 'center center',
        backgroundRepeat: 'no-repeat',
        backgroundSize: 'contain',
        borderRadius: '5px',
    }),

    summaryWrap: css({
        position: 'sticky',
        top: 60,
        float: 'left',
        padding: '30px 20px 0 20px',
        backgroundColor: colors.BLUE_EXTRA_LIGHT,
        minHeight: 'calc(100vh - 60px)',
        paddingBottom: 20,
        width: '100%',

        '.tm-text': {
            fontSize: 15,
            lineHeight: '145%',
            letterSpacing: '0.02em',
            textAlign: 'center',
            marginTop: 40,
            marginBottom: 40,
            marginLeft: -20,
            marginRight: -20,
            color: 'rgba(21, 32, 107, 0.5)'
        },

        '.mobile-errors': {
            color: colors.RED,
            textAlign: 'center',
            marginBottom: 8,
            fontSize: 15,
        },

        '.checokut-title-wrapper': {
            marginBottom: 15,
            display: 'flex',
            flexDirection: 'row',
            flexWrap: 'nowrap',
            alignContent: 'center',
            justifyContent: 'space-between',
            alignItems: 'flex-end',

            '.checokut-title': {
                fontStyle: 'normal',
                fontWeight: 'bold',
                fontSize: 24,
                lineHeight: '135%',
                letterSpacing: '0.02em',
                color: colors.BLUE,
            },

            '.back-to-cart': {
                fontStyle: 'normal',
                fontWeight: 'bold',
                fontSize: 15,
                lineHeight: '135%',
                display: 'flex',
                alignItems: 'center',
                letterSpacing: '0.02em',
                textDecorationLine: 'underline',
                color: colors.BLUE,
            }
        },

        '.save-btn': {
            marginBottom: 20,
            height: '45px',
        },

        'p.refund-policy': {
            fontWeight: 500,
            fontSize: 13,
            color: colors.BLUE,
            lineHeight: 1.15,
            textAlign: 'left',
            marginBottom: 50,
            span: {
                textDecoration: 'underline',
                cursor: 'pointer',
            },
        },

        /*
        [mobileOnly]: {
            float: 'none',
            width: '100%',
            padding: '24px 20px',
            marginTop: 20,

            '.mobile-errors': {
                display: 'block',
            },
        },
        */

        '.summary-table': {
            marginBottom: 20,
            '.promo-add': {
                padding: '5px',
            },
            '.sum-row-hr': {
                width: '100%',
                height: 1,
                backgroundColor: '#fff',
                margin: '12px 0',

                [mobileOnly]: {
                    margin: '16px 0',
                },
            },
            '.product-rows': {
                borderRadius: 5,
                border: `1px solid ${colors.BLUE_LIGHT}`,
                backgroundColor: colors.WHITE,
                margin: '0 -15px 15px -15px',
                padding: 15,

                [mobileOnly]: {
                    margin: '0 0 15px 0',
                },

                '.toggle': {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'flex-start',
                    flexWrap: 'wrap',
                    textAlign: 'left',
                    width: '100%',
                    cursor: 'pointer',
                    background: 'transparent',
                    borderRadius: 0,
                    lineHeight: '21.75px',
                    fontWeight: 700,
                    outline: 'none',
                    letterSpacing: '0.01em',
                    marginRight: '-0.01em',
                    border: 0,
                    padding: 0,

                    '.toggle-row': {
                        flexGrow: 1,
                        width: '100%',
                        display: 'flex',

                        '.box-caption': {
                            fontSize: 16,
                            marginRight: 14,
                            color: colors.NAVY,

                            '.arrow': {
                                marginRight: 'auto',
                                marginLeft: 14,
                            },
                        },
                        '.box-total': {
                            marginLeft: 'auto',
                            fontSize: 16,
                            lineHeight: '23.2px',
                            color: colors.NAVY,
                            fontWeight: 600,
                        },
                        '.box-edit': {
                            marginLeft: 'auto',
                            textDecoration: 'underline',
                            fontSize: 15,
                            cursor: 'pointer',
                            color: colors.BLUE,
                            fontWeight: 600,
                        },
                        '.items-count': {
                            width: '100%',
                            textAlign: 'left',
                            marginRight: 'auto',
                            fontSize: 14,
                            color: colors.BLUE,
                            lineHeight: '145%',
                            fontWeight: 400,
                        },
                    }
                },
                '.content': {
                    marginTop: 15,

                    '.sum-row': {
                        letterSpacing: '0.01em',
                        '.caption': {
                            fontSize: 13,
                            marginRight: 10,
                        },
                        '.total': {
                            fontSize: 13,

                            '&.with-discount': {
                                'span:first-child': {
                                    textDecorationLine: 'line-through',
                                    marginRight: 6,
                                },
                                'span:last-child': {
                                    color: colors.GREEN_BRIGHT,
                                }
                            },
                        },
                    },
                },
            },
            '.add-box': {
                marginBottom: 17,
                textAlign: 'center',
            },
            '.sum-row': {
                display: 'flex',
                alignItems: 'flex-start',
                justifyContent: 'space-between',

                '&.standard-shipping': {
                    marginBottom: 13,
                },

                '.caption, .total': {
                    display: 'flex',
                    fontWeight: 600,
                    fontSize: 15,
                    color: colors.NAVY,

                    input: {
                        paddingTop: 2,
                    },
                },

                '&.total': {
                    marginBottom: 4,

                    '.caption': {
                        color: colors.NAVY,
                    },
                },

                '&.total.coupon': {
                    position: 'relative',

                    '.caption, .total': {
                        color: colors.GREEN_BRIGHT,
                    },

                    '.caption': {
                        position: 'relative',
                    },

                    '.coupon-remove-btn': {
                        position: 'absolute',
                        left: '-25px',
                        top: '50%',
                        transform: 'translate(0, -50%)',

                        'img': {
                            marginTop: 10,
                        },

                        '&:hover': {
                            cursor: 'pointer',
                        },

                        [mobileOnly]: {
                            left: 'initial',
                            right: '-25px',
                        },
                    },
                },

                '&.shipping': {
                    '&.active': {
                        '.radio': {
                            '&:after': {
                                content: '" "',
                                position: 'absolute',
                                top: '50%',
                                left: '50%',
                                transform: 'translate(-50%, -50%)',
                                width: 9,
                                height: 9,
                                backgroundColor: colors.BLUE,
                                borderRadius: '50%',
                            },
                        },
                        '.infos': {
                            'p.name': {
                                color: colors.NAVY,
                                opacity: 1,
                            },
                            'p.expected-date': {
                                opacity: 1,
                            },
                        },
                        '.total': {
                            opacity: 1,
                        }
                    },

                    '&:hover': {
                        cursor: 'pointer',
                    },

                    '.caption': {
                        marginBottom: 0,
                        paddingBottom: '0px !important',
                    },

                    '.radio': {
                        position: 'relative',
                        width: 18,
                        height: 18,
                        border: `2px solid ${colors.BLUE}`,
                        backgroundColor: '#fff',
                        borderRadius: '50%',
                        float: 'left',
                        margin: '5px 10px 0 0',
                    },

                    '.infos': {
                        marginLeft: 5,

                        'p.name': {
                            fontWeight: 600,
                            fontSize: 15,
                            color: colors.BLUE,
                            opacity: 0.7,
                            margin: 0,
                            lineHeight: 1.35,
                        },

                        'p.expected-date': {
                            fontWeight: 600,
                            fontSize: 13,
                            color: colors.BLUE,
                            opacity: 0.7,
                            margin: 0,
                            lineHeight: 1.15,
                        },
                    },

                    '.total': {
                        alignSelf: 'flex-start',
                        color: colors.BLUE,
                        opacity: 0.7,

                        '&.green': {
                            color: colors.GREEN_BRIGHT,
                        },
                    },
                },

                '&.promo-code': {
                    display: 'block',
                    textAlign: 'center',

                    p: {
                        margin: '3px 0',
                        textDecoration: 'underline',
                        fontSize: 15,
                        fontWeight: 600,
                        color: colors.BLUE,

                        '&:hover': {
                            cursor: 'pointer',
                        }
                    },

                    '.referral-coupon': {
                        color: colors.NAVY,
                        fontSize: 15,
                        textAlign: 'center',
                        padding: '0px 20px',
                        lineHeight: '125%',
                        marginBottom: 12,

                        '.code': {
                            color: colors.GREEN_BRIGHT,
                        },
                    },

                    '.input-holder': {
                        position: 'relative',

                        input: {
                            border: 0,
                            lineHeight: '45px',
                            padding: '0 20px',
                        },

                        '.apply-btn': {
                            position: 'absolute',
                            padding: 0,
                            right: 20,
                            top: '50%',
                            transform: 'translate(0, -50%)',
                            fontSize: 15,
                            color: colors.BLUE,
                            fontWeight: 600,
                            background: 'none',
                            border: 0,
                            outline: 0,
                            textTransform: 'uppercase',

                            '&:hover': {
                                cursor: 'pointer',
                            },
                        },
                    },

                    '.notification-msg': {
                        display: 'flex',
                        alignItems: 'center',
                        marginTop: 8,

                        img: {
                            width: 14,
                            marginRight: 7,
                        },

                        span: {
                            fontSize: 13,
                            fontWeight: 600,
                            textAlign: 'left',
                            lineHeight: '1.2',
                        },

                        '&.error': {
                            span: {
                                color: colors.RED_DARK,
                            },
                        },

                        '&.success': {
                            justifyContent: 'center',

                            span: {
                                color: colors.GREEN_BRIGHT,
                            },
                        }
                    }
                },

                '&.order-total': {
                    '.caption, .total': {
                        fontSize: 15,
                        fontWeight: 600,
                        color: colors.NAVY,
                    },
                },
            },
            '.shipment-info': {
                fontSize: 13,
                color: colors.BLUE,
            },
        },

        '.checkout-message': {
            lineHeight: 'initial',
        },

        '.actions-wrapper': {
            padding: '20px 25px',
            margin: '-25px -25px 0',
            background: colors.WHITE,
            borderTop: '2px solid',
            borderColor: colors.BLUE_EXTRA_LIGHT,
            fontSize: 15,
            fontWeight: 400,
            color: colors.BLUE,
            lineHeight: '145%',

            '.hr': {
                height: 1,
                backgroundColor: colors.BLUE_EXTRA_LIGHT,
                marginTop: 15,
            },

            '.line': {
                display: 'flex',
                justifyContent: 'space-between',
                marginTop: 15,

                '& > .text': {
                    flex: 1,
                    paddingRight: 5
                },

                '& > .title': {
                    paddingRight: 20
                },

                '&~.line': {
                    marginTop: 10
                },

                '.title': {
                    fontWeight: 600
                }
            },

            [tabletLandscapeUp]: {
                margin: 0,
                borderRadius: 20,
                border: '1px solid',
                borderColor: '#cfd5e5'
            }
        },

        [mobileOnly]: {
            '.product-rows': {
                '.sum-row': {
                    marginBottom: 5,
                },
            },

            '.summary-table': {
                '.sum-row': {
                    '&.total': {
                        marginBottom: 8,
                    }
                },
            },

            '.tm-text': {
                marginLeft: 20,
                marginRight: 20,
                marginTop: 50,
                marginBottom: 50,
            },
        },

        [tabletPortraitUp]: {
            float: 'none',
            padding: '30px 60px',
        },

        [tabletLandscapeUp]: {
            padding: '50px 70px 30px 60px',
        },

        [desktopUp]: {
            width: '100%',
            padding: '50px 100px 40px 80px',
        },
    }),

    deliveryDate: css({
        display: 'flex',
        flexDirection: 'row',
        justifyContent: 'space-between',

        p: {
            color: colors.BLUE
        }
    }),
};
